import { Component, Input } from "@angular/core";

@Component({
	selector: "html-asset",
	template:
		'<iframe [src]="path|safeUrl" frameBorder="0" scrolling="no"></iframe>',
	styleUrls: ["./html-asset.css"],
})
export class HtmlAssetDirective {
	@Input()
	public path: string;
	constructor() {}
}
